<template>
  <div>
    <app-header title="Xero Settings" />
    <div class="container container-fluid mt-4 mb-4">

        <div class="page-heading">

            <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col d-flex align-items-center">
                      <h2 class="mb-2">Xero API</h2>
                    </div>
                    <div v-if="!link" class="col-auto d-flex align-items-center"><span class="status status-success">Linked</span></div>
                    <div v-else class="col-auto d-flex align-items-center"><span class="status status-danger">Unlinked</span></div>
                  </div>
                  <div v-if="link">
                      <div class="alert alert-danger" role="alert" v-if="data.refresh_token_failed">
                          We have been unable to refresh your Xero Access Token and therefore your Xero link is current <strong>disabled</strong>. In order to re-activate your link please "Disconnect" the connected Application here: <a href="https://identity.xero.com/account/apps/" target="blank">Connected Applications</a> then re-link Xero below.
                      </div>
                      <a class="btn btn-primary" v-bind:href="link">Link Xero <i class="far fa-sign-in"></i></a>
                  </div>
                </div>
                <ul class="list-data no-links no-hover">
                  <li>
                    <div class="row">
                      <div class="col">
                        <strong>Tenant Type</strong>
                      </div>
                      <div class="col">
                        {{data.tenant_type}}
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="row">
                      <div class="col">
                        <strong>Tenant ID</strong>
                      </div>
                      <div class="col">
                        {{data.tenant_id}}
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="row">
                      <div class="col">
                        <strong>Tenant Name</strong>
                      </div>
                      <div class="col">
                        {{data.tenant_name}}
                      </div>
                    </div>
                  </li>
                </ul>
            </div>

            <div class="card">
              <div class="card-body pb-0">
                <h2 class="mb-0">API Usage Limits</h2>
              </div>
              <ul class="list-data no-links no-hover">
                <li>
                  <div class="row">
                    <div class="col"><strong>Day Limit Remaining</strong></div>
                    <div class="col">{{data.day_limit_remaining}}</div>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col"><strong>Minute Limit Remaining</strong></div>
                    <div class="col">{{data.min_limit_remaining}}</div>
                  </div>
                </li>
              </ul>
            </div>
        </div><!-- /.page-heading -->

    </div><!-- /.wrapper -->
  </div>
</template>

<script>

    import { http } from 'utils'

    export default {

        data: function () {
            return {
                link: null,
                data: []
            }
        },

        mounted() {

            http.get('/codium/xero/oauth2/link').then((response) => {
                if (response.data && response.data.link) this.link = response.data.link;
            }).catch(function (error) {
                if (error.response && error.response.status) {
                    notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                }
            });

            http.get('/codium/xero/oauth2').then((response) => {
                if (response.data) this.data = response.data;
            }).catch(function (error) {
                if (error.response && error.response.status) {
                    notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                }
            })
        }
    }
</script>
